import React, { FC } from 'react';
import { HrefLang, RegionWithLangs } from '@navi-toolbox/seo';
import { useSelector } from 'react-redux';
import { getBaseUrl } from 'common/selectors/location';
import { HelmetContext } from '@okapi/helmet-react';

type Props = {
  context: HelmetContext;
};

export const HrefLangMeta: FC<Props> = ({ context }) => {
  const regions: RegionWithLangs[] = [
    {
      regionCodeIS03166: 'ru',
      languagesISO639: ['ru'],
    },
    {
      regionCodeIS03166: 'kz',
      languagesISO639: ['ru', 'kk'],
    },
  ];
  const currentPage = useSelector(getBaseUrl);
  if (!currentPage || typeof currentPage !== 'string') {
    return null;
  }
  return <HrefLang regions={regions} url={currentPage} context={context} />;
};
